import MainLayout from "@/components/layout/company/MainLayout.vue";
import TwspNameJson from "@/assets/json/township.json";
import RegionJson from "@/assets/json/region.json";
import { required, maxLength } from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import $ from "jquery";
import axios from "axios";
import { mapGetters } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "jobPostCreate",

    components: {
        MainLayout,
        DatePicker,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            isCategoryDropdownOpen: false,
            isRegionDropdownOpen: false,
            isTownshipDropdownOpen: false,
            isJobTypeDropdownOpen: false,
            // company_id: "",
            category_id: "",
            category_name: "",
            job_title: "",
            min_salary: "",
            max_salary: "",
            job_type: "",
            description: "",
            short_desc: "",
            expired_date: "",
            gender: 1,
            experience: "",
            qualification: "",
            //   latitude: "",
            //   longitude: "",
            region: "",
            town: "",
            address: "",
            category: [],
            company: [],
            jobType: [{
                    value: "1",
                    name: "Full-time"
                },
                {
                    value: "2",
                    name: "Part-time"
                },
                {
                    value: "3",
                    name: "Internship"
                },
                {
                    value: "4",
                    name: "Freelance"
                },
                {
                    value: "5",
                    name: "Remote Job"
                }
            ],
            submitted: false,
            regionArr: RegionJson,
            selectedTwspName: "",
            twspNameJson: TwspNameJson,
            twspName: []
        };
    },

    computed: {
        ...mapGetters({ companyId: "companyId" }),
        selectedCategoryName() {
            if (!this.category || !Array.isArray(this.category)) return '';
            const selected = this.category.find(cat => cat.id === this.category_id);
            return selected ? selected.category_name : '';
        },
        selectedRegionName() {
            if (this.region === '' || this.region === null || this.region === undefined) return '';
            return this.regionArr[this.region] || '';
        },
        selectedJobTypeName() {
            const selected = this.jobType.find(option => option.value === this.job_type);
            return selected ? selected.name : '';
        }
    },

    validations: {
        category_name: {
            required
        },
        job_title: {
            required,
            maxLength: maxLength(100)
        },
        // min_salary: {
        //     numeric
        // },
        // max_salary: {
        //     numeric
        // },
        job_type: {
            required
        },
        description: {
            required
        },
        short_desc: {
            required
        },
        expired_date: {
            required
        },
        gender: {
            required
        },
        region: {
            required
        },
        // town: {
        //     required
        // },
        address: {
            // required,
            maxLength: maxLength(200)
        }
    },

    methods: {
        toggleCategoryDropdown() {
            this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
            this.isRegionDropdownOpen = false;
            this.isTownshipDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectCategory(id, name) {
            this.category_id = id;
            this.category_name = name;
            this.isCategoryDropdownOpen = false;
        },

        toggleRegionDropdown() {
            this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isTownshipDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectRegion(id) {
            this.region = id;
            this.selectedTwspName = "";
            this.town = "";
            this.twspName = (id !== '' && id !== null && id !== undefined) ? this.changeTwspName(id) : [];
            this.isRegionDropdownOpen = false;
        },

        toggleTownshipDropdown() {
            if (this.region !== '' && this.region !== null && this.region !== undefined) {
                this.isTownshipDropdownOpen = !this.isTownshipDropdownOpen;
            }
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectTownship(value) {
            this.town = value;
            this.isTownshipDropdownOpen = false;
        },

        toggleJobTypeDropdown() {
            this.isJobTypeDropdownOpen = !this.isJobTypeDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
            this.isTownshipDropdownOpen = false;
        },

        selectJobType(value) {
            this.job_type = value;
            this.isJobTypeDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isCategoryDropdownOpen = false;
                this.isRegionDropdownOpen = false;
                this.isTownshipDropdownOpen = false;
                this.isJobTypeDropdownOpen = false;
            }
        },

        onChange(event) {
            var optionValue = event.target.value;
            this.job_type = optionValue;
        },

        // onCompanyChange(event) {
        //     var optionValue = event.target.value;
        //     var optionText = event.target.options[event.target.options.selectedIndex].text;
        //     this.company_id = optionValue;
        //     this.company_name = optionText;
        // },

        onCategoryChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.category_id = optionValue;
            this.category_name = optionText;
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.region = Value;
            this.selectedTwspName = "";
            this.town = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.town = Value;
        },

        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },

        submit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.jobCreate();
        },

        jobCreate() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            var request = {
                company_id: this.companyId,
                category_id: this.category_id,
                job_title: this.job_title,
                min_salary: this.min_salary,
                max_salary: this.max_salary,
                job_type: this.job_type,
                description: this.description,
                short_desc: this.short_desc,
                expired_date: this.expired_date,
                gender: this.gender,
                experience: this.experience,
                qualification: this.qualification,
                // latitude: this.latitude,
                // longitude: this.longitude,
                region: this.region,
                town: this.town,
                address: this.address
            };
            axios.post("/company/job/create", request)
                .then(() => {
                    this.$notification.success("အလုပ်ပိုစ့်တင်ခြင်းအောင်မြင်သည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.isLoading = false;
                    this.$router.push({
                        name: "companyIndex"
                    });
                })
                .catch(error => {
                    $("#block-btn").attr("disabled", false);
                    this.isLoading = false;
                    this.$notification.error("Job Adding Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", error);
                });
        },

        getCategoryForJob() {
            axios.get("/job/category/list")
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log("Category List API Error", error);
                })
        }
    },

    mounted() {
        this.getCategoryForJob();
        window.addEventListener('click', this.handleOutsideClick);

        // $("#min_salary").on("keypress keyup blur", function (event) {
        //     $(this).val($(this).val().replace(/[^\d].+/, ""));
        //     if ((event.which < 48 || event.which > 57)) {
        //         event.preventDefault();
        //     }
        // });

        // $("#max_salary").on("keypress keyup blur", function (event) {
        //     $(this).val($(this).val().replace(/[^\d].+/, ""));
        //     if ((event.which < 48 || event.which > 57)) {
        //         event.preventDefault();
        //     }
        // });
    },

    beforeDestroy() {
        window.removeEventListener('click', this.handleOutsideClick);
    }
};
